export enum ToggleFeatureKeys {
  Unknown = '',
  PilotWebFilterTrainings = 'pilot-web-filter-training-packages',
  PilotWebWebDarkMode = 'pilot-web-dark-mode',
  PilotWebLearningPlatform = 'pilot-web-learning-platform',
  PilotWebMyTrainings = 'pilot-web-my-trainings',
  PilotWebCurrentAndUpcomingBookings = 'pilot-web-current-and-upcoming-bookings',
  PilotWebErrorPageRedirect = 'pilot-web-error-page-redirect',
  PilotWebAppHeap = 'pilot-web-app-heap',
  PilotWebAppSchedulePage = 'pilot-web-app-schedule-Page',
  PilotWebAppTrainingCenterPage = 'pilot-web-app-TrainingCenter-Page',
  PilotWebAppDirectionsPage = 'pilot-web-app-Direction-Page',
  PilotWebAppTrainingRecords = 'pilot-web-app-Training-Records',
  PilotWebAppImportantRequirementsIacra = 'pilot-web-app-Important-Requirements-Iacra',
  PilotWebAppImportantRequirementsTsa = 'pilot-web-app-Important-Requirements-Tsa',
  PilotWebAppImportantRequirements = 'pilot-web-app-Important-Requirements',
  PilotWebAppSystemNotificationCatFto = 'cct-system-notifications-cat-fto',
  PilotWebAppSystemNotificationBat = 'cct-system-notifications-BAT',
  PilotWebGlobalNotification = 'cct-system-notification-global',
  PdftronBookmark = 'cct-web-pdftron-bookmark',
  PdftronPrint = 'pdf-print-function',
  IsPrintable = 'cct_imc_get_document_isprintable',
  PilotWebAppDocumentMenuModal = 'cct-web-document-drop-down-menu',
  PilotWebAppFiltersPanel = 'cct-web-document-filter',
  DisplayScheduleAtReservationConfirmationFeature = 'cct-schedule-display-at-reservation-confirmation',
  DisplayScheduleSessionColorFeature = 'cct-web-schedule-session-color',
  DisplayScheduleDescriptionFeature = 'cct-web-schedule-description',
  DisplayFirstWeekScheduleFeature = 'cct-first-week-schedule-display',
  DisplayFullScheduleAtConfirmationFeature = 'cct-full-schedule-display',
  DocumentDownloadSecurity = 'cct-web-document-download-security',
  DocumentLoadingScreensFeature = 'cct-web-document-loading-screen',
  PelesysBatIntegration = 'cct-bat-pelesys-integration',
  PilotWebAppTrainingsCardListView = 'cct-web-trainings-card-list-view',
  PilotWebAppDocumentRejection = 'cct-web-pilot-web-app-document-rejection',
  SMSNotificationRollout = 'cct-sms-notification-rollout',
  DisplayDecommissionInfoBanner = 'cct-display-decommission-info-banner',
  DisplayDecommissionModal = 'cct-display-decommission-modal'
}
